// @ts-nocheck
import { T } from '@/v2/helpers/i18n';
import React, { Component } from 'react';
import { RootContext } from '@/root/root.provider';
import { Button } from '@ticketmaster/global-design-system';
import { Trans, withTranslation } from 'react-i18next';
import AlertBanner from '../../banner/alertBanner';

import styles from './manageTicketButton.module.scss';
import { EventModel } from '@/v2/models/eventModel.ts';
import { RedemptionAvailabilityModel } from '@/v2/models/multiEventEnvelopeModel.ts';

type Props = {
  activeToken: string;
  event: EventModel;
  redemptionAvailability: RedemptionAvailabilityModel;
  tmOrderUrl: string;
} & T;

type State = {
  showBanner: boolean
  isLoading: boolean
};

class ManageTicketButton extends Component<Props, State> {

  static contextType = RootContext;

  state = {
    showBanner: false,
    isLoading: false
  };

  checkDisabled(subSystemSource: string, redemptionDisabled: boolean | undefined) {
    return this.isEmpty(subSystemSource) || !!redemptionDisabled;
  }

  render() {
    const { activeToken, event, redemptionAvailability, tmOrderUrl } = this.props;
    const isDisabled = this.checkDisabled(event?.subSystemSource, redemptionAvailability?.redemptionDisabled);
    if (tmOrderUrl) {
      return (
        <div className={styles.manageTicketsButton}>
          <Button fullWidth onClick={() => window.location.assign(tmOrderUrl)}>
            <Trans>{'WALLET.TICKETS.MANAGE'}</Trans>
          </Button>
        </div>
      );
    } else if (!this.state.showBanner) {
      return (
        <div className={styles.manageTicketsButton} onClick={() => {
          if (isDisabled) {
            this.setState({ showBanner: true });
          }
        }}>
          <Button
            fullWidth
            loading={{ isLoading: this.state.isLoading }}
            className={isDisabled ? styles.disabled : null}
            onClick={async () => {
              if (!isDisabled && !this.state.isLoading) {
                this.setState({ isLoading: true });
                await this.context.addToAccount(activeToken);
                this.setState({ isLoading: false });
              }
            }}
          >
            <Trans>{'WALLET.TICKETS.MANAGE'}</Trans>
          </Button>
        </div>
      );
    } else {
      return <AlertBanner onClose={() => this.setState({ showBanner: false })} redemptionAvailability={redemptionAvailability}/>;
    }
  }

  private isEmpty(subSystemSource: string) {
    return (subSystemSource == null || subSystemSource.length === 0);
  }
}

export default withTranslation('translation')(ManageTicketButton);
